import { NavLink } from 'react-router-dom'
import {
	Banknote,
	LayoutDashboard,
	Receipt,
	Scale,
	UserCheck,
	Wallet,
	Wrench,
	X,
} from 'lucide-react'

// Menu espelhando a pasta BackOffice da collection API.postman_collection.json
export const navSections = [
	{
		title: null,
		items: [{ name: 'Dashboard', href: '/', icon: LayoutDashboard, end: true }],
	},
	{
		title: 'BackOffice',
		items: [
			{ name: 'Contas', href: '/contas', icon: Wallet },
			{ name: 'Saldos x QITech', href: '/saldos-qitech', icon: Scale },
			{ name: 'Onboardings', href: '/onboardings', icon: UserCheck },
			{ name: 'Pagadoria', href: '/pagadoria', icon: Banknote },
			{ name: 'Boletos da pagadoria', href: '/pagadoria/boletos', icon: Receipt },
			{ name: 'Utils', href: '/utils', icon: Wrench },
		],
	},
]

const SidebarContent = ({ onNavigate }) => (
	<div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
		<div className="flex flex-shrink-0 items-center justify-between px-4">
			<div>
				<h1 className="text-xl font-bold text-gray-900">KSI Pay</h1>
				<p className="text-xs text-gray-500">Painel administrativo</p>
			</div>
			{onNavigate && (
				<button
					type="button"
					onClick={onNavigate}
					className="text-gray-400 hover:text-gray-600 md:hidden"
					aria-label="Fechar menu"
				>
					<X className="h-5 w-5" />
				</button>
			)}
		</div>

		<nav className="mt-6 flex-1 space-y-6 px-2 pb-4">
			{navSections.map((section, index) => (
				<div key={section.title || `section-${index}`}>
					{section.title && (
						<p className="px-2 pb-2 text-xs font-semibold uppercase tracking-wider text-gray-400">
							{section.title}
						</p>
					)}
					<div className="space-y-1">
						{section.items.map((item) => (
							<NavLink
								key={item.href}
								to={item.href}
								end={item.end}
								onClick={onNavigate}
								className={({ isActive }) =>
									`group flex items-center rounded-md px-2 py-2 text-sm font-medium ${
										isActive
											? 'bg-primary-50 text-primary-700'
											: 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
									}`
								}
							>
								{({ isActive }) => (
									<>
										<item.icon
											className={`mr-3 h-5 w-5 flex-shrink-0 ${
												isActive
													? 'text-primary-600'
													: 'text-gray-400 group-hover:text-gray-500'
											}`}
										/>
										{item.name}
									</>
								)}
							</NavLink>
						))}
					</div>
				</div>
			))}
		</nav>
	</div>
)

const Sidebar = ({ isOpen, onClose }) => (
	<>
		<div className="hidden md:flex md:w-64 md:flex-col">
			<SidebarContent />
		</div>

		{isOpen && (
			<div className="fixed inset-0 z-40 flex md:hidden">
				<div
					className="fixed inset-0 bg-gray-600 bg-opacity-75"
					onClick={onClose}
					aria-hidden="true"
				/>
				<div className="relative flex w-64 flex-col">
					<SidebarContent onNavigate={onClose} />
				</div>
			</div>
		)}
	</>
)

export default Sidebar
